export const AVATAR_SIZE = 40;
export const POPOVER_WIDTH = 320;
